import React, {Component} from 'react';
import {sortByProperty} from 'helpers/sorters';
import {getDefaultExposure} from 'helpers/player-helper';
import {ComboExposureInputComponent} from 'components/organisms/teams-combinations/components/combo-exposure-input';
import {calcPercentage} from 'helpers/common-helper';
import {LineupStackExtractor} from 'services/lineup-stack-extractor';
import FilterLineupsByTeamCombinations from 'components/molecules/filter-lineups-by-team-combinations';
import {ComboUnit} from '../combo-unit';

class BaseTeamsCombinations extends Component {
    constructor(props) {
        super(props);
        if (typeof this.getView !== 'function') {
            throw new Error('Method getViewTemplate is undefined.');
        }
    }

    getLineupsQuantity() {
        const {rawLineups, filterLineupsByTeamCombinations} = this.props;

        return filterLineupsByTeamCombinations?.hasCheckedCombinations()
            ? filterLineupsByTeamCombinations.getLineupsQuantity()
            : rawLineups.getQuantity();
    }

    prepareCombo() {
        const {rawLineups, lineupTeamsCombinations} = this.props;

        const uniqueCombo = {};
        rawLineups.asArr().map((lineup) => {
            const teams = this.getStackedTeams(lineup);

            if (!isEmpty(teams)) {
                const index = lineupTeamsCombinations.exposureMax.doIndex(teams);
                uniqueCombo[index] =
                    index in uniqueCombo
                        ? ComboUnit.create(teams, 1 + uniqueCombo[index].getQuantity())
                        : ComboUnit.create(teams, 1);
            }
        });

        const items = lineupTeamsCombinations.exposureMax.all();
        Object.values(items).map((item) => {
            if (!uniqueCombo.hasOwnProperty(item.uid)) {
                uniqueCombo[item.uid] = ComboUnit.create(item.teamsCombination, 0);
            }
        });

        let combo = Object.values(uniqueCombo);
        combo.sort(sortByProperty('quantity', 'desc'));

        return [...combo];
    }

    getStackedTeams(lineup) {
        if (!('marker' in this)) {
            return [];
        }

        const lineupStackExtractor = new LineupStackExtractor(lineup.getOriginalLineup(), this.marker);

        return lineupStackExtractor.getStackedTeams();
    }

    getActualValue(combo) {
        const {lineupTeamsCombinations} = this.props;

        return lineupTeamsCombinations.exposureMax.has(combo.teams)
            ? lineupTeamsCombinations.exposureMax.getValue(combo.teams)
            : getDefaultExposure('max');
    }

    getNotFoundView() {
        return (
            <tr key="teams-not-found" className="empty">
                <td colSpan="3">Teams were not found.</td>
            </tr>
        );
    }

    getCombinationRowView(rowNumber, combo) {
        const {rawLineups} = this.props;
        const currentExpMax = this.getActualValue(combo);
        const percentage = calcPercentage(rawLineups.getQuantity(), combo.getQuantity());
        const className = rowNumber % 2 === 0 ? 'even' : '';

        return (
            <tr key={rowNumber} className={className}>
                <td>
                    <FilterLineupsByTeamCombinations combo={combo} />
                </td>
                <td>
                    <strong>{combo.getTeams().join(' - ')}</strong>
                </td>
                <td className="text-blue">
                    {percentage}% ({combo.getQuantity()})
                </td>
                <td>
                    <div className="percent-in">
                        <ComboExposureInputComponent value={`${currentExpMax}`} combo={combo} />
                        <span className="percent">%</span>
                    </div>
                </td>
            </tr>
        );
    }

    render() {
        const combo = this.prepareCombo();

        if (isEmpty(combo)) {
            return this.getView({
                combosQuantity: 0,
                content: <tbody>{this.getNotFoundView()}</tbody>,
            });
        }

        const usedCombinations = [];
        const unusedCombinations = [];
        combo.map((item, i) => {
            const combinationRowView = this.getCombinationRowView(i, item);
            if (item.isUsedInLineup()) {
                usedCombinations.push(combinationRowView);
            } else {
                unusedCombinations.push(combinationRowView);
            }
        });

        return this.getView({
            combosQuantity: combo.length,
            content: [
                <tbody key="0">{usedCombinations}</tbody>,
                <tbody key="1" className="unused-combinations">
                    {unusedCombinations}
                </tbody>,
            ],
        });
    }
}

export {BaseTeamsCombinations};
